// ParentConsent.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ParentConsent = () => {
  const [formData, setFormData] = useState({
    studentName: '',
    studentGrade: '',
    studentClass: '',
    studentNumber: '',
    parentName: '',
    parentPhone: '',
    parentEmail: '',
    consentAI: false,
    consentData: false,
    consentMonitoring: false
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const generatePDF = () => {
    // 실제 PDF 파일 다운로드
    const link = document.createElement('a');
    link.href = '/AI_학습_지원_서비스_이용_동의서.pdf';
    link.download = 'AI_학습_지원_서비스_이용_동의서.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const isFormValid = () => {
    return formData.studentName && 
           formData.studentGrade && 
           formData.parentName && 
           formData.consentAI && 
           formData.consentData && 
           formData.consentMonitoring;
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 헤더 */}
        <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <img src="/logo.png" alt="청해 AI" className="h-12 w-12" />
              <div>
                <h1 className="text-3xl font-bold text-gray-900">학부모 동의서</h1>
                <p className="text-gray-600">SafeAI Kids Platform Parent Consent Form</p>
              </div>
            </div>
            <Link 
              to="/" 
              className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors"
            >
              홈으로 돌아가기
            </Link>
          </div>
        </div>

        {/* 안내 정보 */}
        <div className="bg-blue-50 rounded-lg p-6 mb-6">
          <div className="flex items-start space-x-3">
            <div className="text-2xl">ℹ️</div>
            <div>
              <h3 className="text-lg font-semibold text-blue-800 mb-2">동의서 작성 안내</h3>
              <ul className="text-blue-700 space-y-1 text-sm">
                <li>• 본 동의서는 학생의 안전한 AI 학습을 위해 필요합니다</li>
                <li>• 모든 정보는 교육 목적으로만 사용되며 안전하게 보관됩니다</li>
                <li>• 작성 완료 후 PDF로 다운로드하여 학교에 제출해주세요</li>
              </ul>
            </div>
          </div>
        </div>

        {/* 동의서 양식 */}
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            청해 AI 키즈 플랫폼 이용 동의서
          </h2>

          <div className="space-y-6">
            {/* 학생 정보 */}
            <div className="border-b pb-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">📚 학생 정보</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    학생 이름 *
                  </label>
                  <input
                    type="text"
                    name="studentName"
                    value={formData.studentName}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="홍길동"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    학년 *
                  </label>
                  <select
                    name="studentGrade"
                    value={formData.studentGrade}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  >
                    <option value="">선택하세요</option>
                    <option value="1">1학년</option>
                    <option value="2">2학년</option>
                    <option value="3">3학년</option>
                    <option value="4">4학년</option>
                    <option value="5">5학년</option>
                    <option value="6">6학년</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    반
                  </label>
                  <input
                    type="text"
                    name="studentClass"
                    value={formData.studentClass}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="1"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    번호
                  </label>
                  <input
                    type="text"
                    name="studentNumber"
                    value={formData.studentNumber}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="15"
                  />
                </div>
              </div>
            </div>

            {/* 학부모 정보 */}
            <div className="border-b pb-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">👨‍👩‍👧‍👦 학부모 정보</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    학부모 성명 *
                  </label>
                  <input
                    type="text"
                    name="parentName"
                    value={formData.parentName}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="홍길순"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    연락처
                  </label>
                  <input
                    type="tel"
                    name="parentPhone"
                    value={formData.parentPhone}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="010-1234-5678"
                  />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    이메일
                  </label>
                  <input
                    type="email"
                    name="parentEmail"
                    value={formData.parentEmail}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="parent@example.com"
                  />
                </div>
              </div>
            </div>

            {/* 동의 항목 */}
            <div>
              <h3 className="text-lg font-semibold text-gray-800 mb-4">✅ 동의 항목</h3>
              <div className="space-y-4">
                <div className="bg-gray-50 p-4 rounded-lg">
                  <label className="flex items-start space-x-3">
                    <input
                      type="checkbox"
                      name="consentAI"
                      checked={formData.consentAI}
                      onChange={handleInputChange}
                      className="mt-1 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    />
                    <div>
                      <span className="font-medium text-gray-900">AI 학습 도구 이용 동의 *</span>
                      <p className="text-sm text-gray-600 mt-1">
                        자녀가 교육 목적으로 AI 채팅 및 이미지 생성 기능을 사용하는 것에 동의합니다.
                      </p>
                    </div>
                  </label>
                </div>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <label className="flex items-start space-x-3">
                    <input
                      type="checkbox"
                      name="consentData"
                      checked={formData.consentData}
                      onChange={handleInputChange}
                      className="mt-1 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    />
                    <div>
                      <span className="font-medium text-gray-900">개인정보 수집 및 이용 동의 *</span>
                      <p className="text-sm text-gray-600 mt-1">
                        교육 목적 및 안전한 서비스 제공을 위한 최소한의 개인정보 수집에 동의합니다.
                      </p>
                    </div>
                  </label>
                </div>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <label className="flex items-start space-x-3">
                    <input
                      type="checkbox"
                      name="consentMonitoring"
                      checked={formData.consentMonitoring}
                      onChange={handleInputChange}
                      className="mt-1 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    />
                    <div>
                      <span className="font-medium text-gray-900">교사 모니터링 동의 *</span>
                      <p className="text-sm text-gray-600 mt-1">
                        자녀의 안전한 AI 이용을 위한 담당 교사의 활동 모니터링에 동의합니다.
                      </p>
                    </div>
                  </label>
                </div>
              </div>
            </div>

            {/* 추가 안내사항 */}
            <div className="bg-yellow-50 p-4 rounded-lg">
              <h4 className="font-semibold text-yellow-800 mb-2">📋 중요 안내사항</h4>
              <ul className="text-yellow-700 text-sm space-y-1">
                <li>• 모든 AI 생성 콘텐츠는 교육에 적합하도록 5단계 필터링을 거칩니다</li>
                <li>• 학생의 모든 활동은 담당 교사가 실시간으로 모니터링합니다</li>
                <li>• 개인정보는 교육 목적으로만 사용되며 제3자와 공유되지 않습니다</li>
                <li>• 언제든지 동의를 철회하고 서비스 이용을 중단할 수 있습니다</li>
              </ul>
            </div>

            {/* 다운로드 버튼 */}
            <div className="text-center pt-6">
              <button
                onClick={generatePDF}
                disabled={!isFormValid()}
                className={`px-8 py-3 rounded-lg font-medium transition-colors ${
                  isFormValid()
                    ? 'bg-blue-600 text-white hover:bg-blue-700'
                    : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                }`}
              >
                📄 동의서 PDF 다운로드
              </button>
              {!isFormValid() && (
                <p className="text-red-500 text-sm mt-2">
                  * 필수 항목을 모두 입력하고 동의해주세요
                </p>
              )}
            </div>
          </div>

          {/* 연락처 정보 */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <div className="text-center text-sm text-gray-600">
              <p className="mb-2">문의사항이 있으시면 언제든지 연락주세요</p>
              <p><strong>개발자:</strong> 완도고등학교 국어교사 공지훈</p>
              <p><strong>이메일:</strong> <a href="mailto:purusil55@gmail.com" className="text-blue-600 underline">purusil55@gmail.com</a></p>
              <p><strong>지원기관:</strong> 완도교육지원청/Upstage</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParentConsent;
